var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagehead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7A86A8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213 212c.552 0 1 .448 1 1v9h1c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L215 223h-10c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L205 222h1v-9c0-.552.448-1 1-1h6zm0 1h-6v9h1v-2h1.5v2h1v-2h1.5v2h1v-9zm-3.5 4v1.5H208V217h1.5zm2.5 0v1.5h-1.5V217h1.5zm-2.5-3v1.5H208V214h1.5zm2.5 0v1.5h-1.5V214h1.5z",
    transform: "translate(-204 -212)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagehead);
export default __webpack_public_path__ + "static/media/imagehead.43b2428255f3073a2c79d0080c8c3f7b.svg";
export { ForwardRef as ReactComponent };